type SentryProvider = typeof import('@/app/providers/sentry')

let sentryProviderPromise: undefined | Promise<SentryProvider>

export function getSentryProvider() {
  if (!sentryProviderPromise) {
    sentryProviderPromise = import('@/app/providers/sentry').catch((error) => {
      sentryProviderPromise = undefined

      throw error
    })
  }

  return sentryProviderPromise
}

export function withSentryProvider(
  callback: (provider: SentryProvider) => void
) {
  getSentryProvider().then(callback).catch((error) => {
    console.warn('[SentryTelemetry] provider import failed', error)
  })
}

export function captureLazySentryException(
  ...args: Parameters<SentryProvider['captureSentryException']>
) {
  withSentryProvider(({ captureSentryException }) => {
    captureSentryException(...args)
  })
}
